import { useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as Spinner } from "../assets/images/spinner.svg";

/**
 * Componente que gerencia a seção de voucher
 * @param {Object} props
 * @param {Function} props.onApplyVoucher - Função a ser chamada quando um voucher é aplicado
 * @returns {JSX.Element}
 */
const VoucherSection = ({ amount, handleContinue, onApplyVoucher }) => {
  const { t } = useTranslation();
  const [voucherCode, setVoucherCode] = useState("");
  const [loading, setLoading] = useState(false);

  const handleVoucherChange = (e) => {
    setVoucherCode(e.target.value.toUpperCase());
  };

  const handleApplyVoucher = () => {
    if (voucherCode.trim().length === 0) return;
    setLoading(true);
    onApplyVoucher(voucherCode);
    setTimeout(() => {
      setLoading(false);
    }, 600);
  };

  const listCurrencyCountry = {
    "usd": { locale: "en-US", currency: "USD" },
    "brl": { locale: "pt-BR", currency: "BRL" },
    "eur": { locale: "de-DE", currency: "EUR" }
  }
  
  // Função para formatar valor monetário corretamente
  const formatCurrency = (value, currencyCode) => {
    if (value === undefined || value === null || !currencyCode) return "";
    
    // Garantir que estamos trabalhando com números
    const numValue = parseFloat(value);
    if (isNaN(numValue)) return "";
    
    // Obter configuração do país/moeda
    const config = listCurrencyCountry[currencyCode] || listCurrencyCountry["usd"];
    // Formatar usando Intl.NumberFormat para garantir formato correto
    return new Intl.NumberFormat(config.locale, {
      style: 'currency',
      currency: config.currency
    }).format(numValue);
  };

  return (
    <>
      <h3>{t("Summary")}</h3>
      
      <div className="payment-summary">
        <div className="payment-row">
          <div className="payment-type">{t("Expert Validation")}</div>
          <div className="payment-amount">{formatCurrency(amount?.amount, amount?.currency)}</div>
        </div>

        { amount?.isValid && (<div className="payment-row">
          <div className="payment-type" style={{ color: 'red' }}>{amount?.voucher}</div>
          <div className="payment-amount"  style={{ color: 'red' }}>- {formatCurrency(amount?.amountDiscounted, amount?.currency)}</div>
        </div>)}
        
        { !amount?.amountDiscounted && (<div className="voucher-section">
          <p>{t("Have a voucher?")}</p>
          <div className="voucher-input">
            <input 
              type="text" 
              placeholder={t("Add voucher and apply")} 
              value={voucherCode}
              onChange={handleVoucherChange}
            />
            <button 
              disabled={voucherCode.trim().length <  1}
              type="button" 
              className="apply-button" 
              onClick={handleApplyVoucher}
            >
              {loading ? <Spinner /> : t("APPLY")}
            </button>
          </div>
        </div>)}
        
        <div className="payment-row total">
          <div className="payment-type">{t("TOTAL")}</div>
          <div className="payment-amount">{formatCurrency(amount?.amountTotal, amount?.currency)}</div>
        </div>
      </div>
      <div className="action-buttons" style={{justifyContent: "flex-end"}}>
        <button 
          type="button"
          onClick={handleContinue}
          className="continue-button"
        >
          {t("Continue")}
        </button>
      </div>
    </>
  );
};

export default VoucherSection; 